import { decrypt, authEncryptDecryptKey } from "./commonHelpers";
import { apiCall } from "./apiCall";
import { API_GET_SECRET_BY_TYPE } from "./apiUrls";

export const commonConfigUtility = async (type, dataType) => {
  return JSON.parse(
    decrypt(
      window.localStorage[dataType] ||
        (await getConfigurationList(type, dataType)),
      authEncryptDecryptKey
    )
  );
};

const getConfigurationList = async (type, dataType) => {
  const response = await apiCall(`${API_GET_SECRET_BY_TYPE}/${type}`);
  window.localStorage.setItem(dataType, response.content.Data);
  return response.content.Data;
};
